(() => {
  class LemonaidPharmacyFormController {
    constructor($rootScope, $scope, $timeout, $interval, toastr, $state, ngDialog, Utils, Orders, Notifications) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        toastr,
        $state,
        ngDialog,
        Utils,
        Orders,
        Notifications,
        pharmacyfill_id: $scope.ngDialogData.pharmacyfill_id
      });
      $scope.$on('ngDialog.opened', function (e, $dialog) {
        $(".ngdialog-theme-default.lemonaid-pharmacy-form-modal").children(".ngdialog-content").draggable({
          handle: ".lemonaid-handler"
        });
      }); // As Meryl confirmed
      // We will always show ALL statuses
      // We will not restrict any status by now => Change on the original design
      // Maybe in the future we will

      this.lemonaidPharmacyMailorderStatuses = [{
        type: "in-progress",
        name: 'In Progress'
      }, {
        type: 'on-hold',
        name: 'On Hold'
      }, {
        type: "cancelled",
        name: 'Cancelled'
      }, {
        type: 'delivered',
        name: 'Delivered'
      }, {
        type: 'error',
        name: 'Error'
      }, {
        type: 'ordered',
        name: 'Ordered'
      }, {
        type: 'sent',
        name: 'Sent'
      }, {
        type: 'shipped',
        name: 'Shipped'
      } // { type: 'open', name: 'Open' },
      // { type: 'incomplete', name: 'Incomplete' },
      ];
      this.getDetails();
    }

    checkNewStatus(newStatus, oldStatus) {
      // As Maksim mentioned in the ticket
      // 'Incomplete' status shouldn't be an option
      // we need to remove 'Cancelled' status, Patient Support has to cancel the fills
      // As Greg confirmed
      // User should not change a fill request to "open"
      // console.log("newStatus: ",newStatus);
      // console.log("oldStatus: ", oldStatus);
      // if (oldStatus === 'incomplete' || newStatus === 'incomplete' ||
      //   oldStatus === 'cancelled' || newStatus === 'cancelled' ||
      //   oldStatus === 'open' || newStatus === 'open') {
      if (oldStatus === 'cancelled' || newStatus === 'cancelled') {
        this.pharmacyfill.status = oldStatus;
        this.toastr.warning("Status can't be changed from '" + oldStatus + "' to '" + newStatus + "'.");
      }
    }

    getDetails() {
      this.Orders.getLemonaidPharmacyMailorder(this.pharmacyfill_id).then(({
        data
      }) => {
        this.pharmacyfill = data;

        if (!this.pharmacyfill.fulfillment_quantity) {
          this.pharmacyfill.fulfillment_quantity = this.pharmacyfill.num_to_send * this.pharmacyfill.dispense_amount;
        }

        if (!this.pharmacyfill.fulfillment_days_supply) {
          this.pharmacyfill.fulfillment_days_supply = this.pharmacyfill.num_to_send * this.pharmacyfill.days_supply;
        }

        if (this.pharmacyfill.shipment && !this.pharmacyfill.shipment.tracking_url) {
          this.pharmacyfill.shipment.tracking_url = "https://tools.usps.com/go/TrackConfirmAction?tLabels=";
        }
      }).catch(err => this.toastr.error(this.Notifications.generic.failure)); // .finally(() => { this.loading = false; });
    }

    close() {
      this.$scope.closeThisDialog(null);
    }

    update() {
      if (!this.pharmacyfill.fulfillment_quantity || isNaN(this.pharmacyfill.fulfillment_quantity)) {
        this.toastr.warning("Please enter refills quantity.");
        return;
      }

      if (!this.pharmacyfill.fulfillment_days_supply || isNaN(this.pharmacyfill.fulfillment_days_supply)) {
        this.toastr.warning("Please enter refills days supply.");
        return;
      }

      if (this.pharmacyfill.status === 'error' && !this.pharmacyfill.notes) {
        this.toastr.warning("Please enter notes.");
        return;
      }

      var tracking_url = this.pharmacyfill.shipment && this.pharmacyfill.shipment.tracking_url ? this.pharmacyfill.shipment.tracking_url : "";
      var payload = {
        status: this.pharmacyfill.status,
        // latest_message: this.pharmacyfill.latest_message ? this.pharmacyfill.latest_message : "",
        notes: this.pharmacyfill.notes ? this.pharmacyfill.notes : "",
        fulfillment_quantity: this.pharmacyfill.fulfillment_quantity,
        fulfillment_days_supply: this.pharmacyfill.fulfillment_days_supply,
        tracking_url: tracking_url
      };
      this.Orders.updateLemonaidPharmacyMailorder(this.pharmacyfill_id, payload).then(() => {
        this.toastr.success("Details were updated successfully.");
        var response = {
          success: true
        };
        this.$scope.closeThisDialog(response);
      }).catch(err => {
        // this.toastr.error(this.Notifications.generic.failure);
        if (err && err.data && err.data.message && err.data.message.summary) {
          this.toastr.error(err.data.message.summary);
        } else {
          this.toastr.error(this.Notifications.generic.failure);
        }
      }); // .finally(() => { this.loading = false; });
    }

  }

  LemonaidPharmacyFormController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "toastr", "$state", "ngDialog", "Utils", "Orders", "Notifications"];
  angular.module('pims').controller('LemonaidPharmacyFormController', LemonaidPharmacyFormController);
})();